export const parseFilterDefaults = (form) => {
    try {
        return JSON.parse(form.dataset.filterDefaults || '{}')
    } catch (error) {
        return {}
    }
}

export const initializeStayLengthRangeValidation = (form) => {
    const minDaysField = form.querySelector('[name="min-dni"]')
    const maxDaysField = form.querySelector('[name="max-dni"]')
    const errorElement = form.querySelector('[data-stay-length-error]')

    if (!minDaysField || !maxDaysField) {
        return
    }

    const clearValidation = () => {
        minDaysField.setCustomValidity('')
        maxDaysField.setCustomValidity('')

        if (errorElement) {
            errorElement.hidden = true
        }
    }

    minDaysField.addEventListener('change', clearValidation)
    maxDaysField.addEventListener('change', clearValidation)
}

export const validateStayLengthRange = (form) => {
    const minDaysField = form.querySelector('[name="min-dni"]')
    const maxDaysField = form.querySelector('[name="max-dni"]')
    const errorElement = form.querySelector('[data-stay-length-error]')

    if (!minDaysField || !maxDaysField) {
        return true
    }

    minDaysField.setCustomValidity('')
    maxDaysField.setCustomValidity('')

    if (errorElement) {
        errorElement.hidden = true
    }

    const minDays = Number(minDaysField.value)
    const maxDays = Number(maxDaysField.value)
    const isValid =
        Number.isInteger(minDays) &&
        Number.isInteger(maxDays) &&
        minDays >= 1 &&
        maxDays >= 1 &&
        minDays <= maxDays

    if (!isValid) {
        const message = form.dataset.invalidLengthMessage || 'Invalid length of stay range.'
        maxDaysField.setCustomValidity(message)

        if (errorElement) {
            errorElement.textContent = message
            errorElement.hidden = false
        }

        maxDaysField.reportValidity()
    }

    return isValid
}

export const buildFilterSearchParams = (form) => {
    const defaults = parseFilterDefaults(form)
    const params = new URLSearchParams()

    for (const [key, rawValue] of new FormData(form).entries()) {
        const value = String(rawValue).trim()

        if (key === 'required' || value === '') {
            continue
        }

        const isDefaultValue =
            Object.prototype.hasOwnProperty.call(defaults, key) &&
            String(defaults[key]) === value

        if (!isDefaultValue) {
            params.append(key, value)
        }
    }

    params.delete('page')
    params.delete('strona')

    return params
}
